import styled from "styled-components";

export const Container = styled.nav`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 0;
`;
